import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export type ProductStatusVariant = "ready" | "needSetup" | "processing"

const statusDotClassNameByVariant: Record<ProductStatusVariant, string> = {
  ready: "bg-status-ready",
  needSetup: "bg-status-idle",
  processing: "animate-pulse bg-vto-accent/40",
}

interface ProductStatusBadgeProps {
  children: ReactNode
  variant: ProductStatusVariant
  className?: string
}

export const ProductStatusBadge = ({ children, variant, className }: ProductStatusBadgeProps) => (
  <span
    className={cn("inline-flex items-center gap-2 text-sm font-medium text-foreground", className)}
  >
    <span
      aria-hidden="true"
      className={cn("size-2.5 shrink-0 rounded-full", statusDotClassNameByVariant[variant])}
    />
    <span className="whitespace-nowrap">{children}</span>
  </span>
)
